<template>
  <ul>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[subscribed_eq]': true })">
        {{ $t('root.filters.yes_subscribed') }}
      </router-link>
    </li>
    <li class="dropdown-item">
      <router-link :to="addToQuery({ page: 1, parent_id: folder.id, 'filters[subscribed_eq]': false })">
        {{ $t('root.filters.no_subscribed') }}
      </router-link>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
  }
</script>
